import { defineStore } from 'pinia'
import {
  fetchRestaurantStaffApi,
  updateRestaurantProfileActiveApi,
} from '@/entities/restaurant/api/restaurantStaffApi'

export const RESTAURANT_STATUS = {
  OPEN: 'open',
  CLOSED: 'closed',
}

export const useRestaurantStore = defineStore('restaurant', {
  state: () => ({
    restaurantId: null,
    restaurantTitle: '',
    supportTelegramUrl: '',
    status: RESTAURANT_STATUS.OPEN,
    isLoading: false,
    isUpdating: false,
    error: null,
    hasLoaded: false,
  }),
  getters: {
    isOpen: (state) => state.status === RESTAURANT_STATUS.OPEN,
    isActive: (state) => state.status === RESTAURANT_STATUS.OPEN,
  },
  actions: {
    clear() {
      this.restaurantId = null
      this.restaurantTitle = ''
      this.supportTelegramUrl = ''
      this.status = RESTAURANT_STATUS.OPEN
      this.isLoading = false
      this.isUpdating = false
      this.error = null
      this.hasLoaded = false
    },

    applyProfile(data) {
      if (!data) {
        return
      }
      if (data.id != null && data.id !== '') {
        this.restaurantId = String(data.id)
      }
      if (data.restaurantTitle) {
        this.restaurantTitle = data.restaurantTitle
      }
      if (typeof data.supportTelegramUrl === 'string') {
        this.supportTelegramUrl = data.supportTelegramUrl.trim()
      }
      if (isValidStatus(data.status)) {
        this.status = data.status
      } else if (typeof data.isActive === 'boolean') {
        this.status = data.isActive ? RESTAURANT_STATUS.OPEN : RESTAURANT_STATUS.CLOSED
      }
    },

    async fetchStaffProfile({ force = false } = {}) {
      if (this.isLoading) {
        return
      }
      if (this.hasLoaded && !force) {
        return
      }

      this.isLoading = true
      this.error = null
      try {
        const data = await fetchRestaurantStaffApi()
        this.applyProfile(data)
        this.hasLoaded = true
      } catch (error) {
        this.error = error
        throw error
      } finally {
        this.isLoading = false
      }
    },

    async setStatus(status) {
      if (!isValidStatus(status)) {
        return
      }
      if (status === this.status || this.isUpdating) {
        return
      }

      const previous = this.status
      const nextActive = status === RESTAURANT_STATUS.OPEN
      this.status = status
      this.isUpdating = true
      this.error = null

      try {
        const data = await updateRestaurantProfileActiveApi(nextActive)
        this.applyProfile(data)
      } catch (error) {
        this.status = previous
        this.error = error
        throw error
      } finally {
        this.isUpdating = false
      }
    },

    async setActive(isActive) {
      return this.setStatus(isActive ? RESTAURANT_STATUS.OPEN : RESTAURANT_STATUS.CLOSED)
    },
  },
})

function isValidStatus(status) {
  return status === RESTAURANT_STATUS.OPEN || status === RESTAURANT_STATUS.CLOSED
}
